import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterDepartementByNamePipe } from 'src/app/shared/pipes/filter-departement-by-name/filter-departement-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { DepartementModalDetailComponent } from './modal/departement-modal-detail/departement-modal-detail.component';
import { DepartementModalAjoutComponent } from './modal/departement-modal-ajout/departement-modal-ajout.component';
import { ListDepartementComponent } from './list-departement/list-departement.component';

@NgModule({
	declarations: [
		ListDepartementComponent,
		DepartementModalDetailComponent,
		DepartementModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterDepartementByNamePipe]
})

export class DepartementModule {}
